import * as yup from 'yup';
import { RequiredNumberSchema } from 'yup/lib/number';
import { RequiredStringSchema } from 'yup/lib/string';
import { AnyObject } from 'yup/lib/types';
import { VALIDATION_CONFIG } from '../config/validation';
import { GoogleMapAddress } from '../types/util';
import { createExcerptFromArray } from './text';

export const validateMimeType = (file: unknown): boolean => {
  if (file instanceof File) {
    return VALIDATION_CONFIG.documentMimetypes.includes(file.type);
  }
  return true;
};

export const validateMaxFileSize = (file: unknown): boolean => {
  if (file instanceof File) {
    return file.size >= 2 && file.size <= VALIDATION_CONFIG.defaultMaxFileSize;
  }
  return true;
};

export const validateDocument = <T>(nullable: true | undefined = true): yup.AnySchema<T, AnyObject, T> => {
  return yup
    .mixed()
    .nullable(nullable)
    .test({
      test: validateMimeType,
      message: `Document must be a file of types ${createExcerptFromArray(
        VALIDATION_CONFIG.documentMimetypes,
        Infinity,
        'or'
      )}`,
    })
    .test({
      test: validateMaxFileSize,
      message: `Document must be under ${VALIDATION_CONFIG.defaultMaxFileSize / 1048576}MiB in size`, // 1048576 = 1024 * 1024 bytes
    });
};

export const googleMapAddressValidations: {
  [K in keyof GoogleMapAddress]: K extends 'location'
    ? RequiredStringSchema<string | undefined, AnyObject>
    : RequiredNumberSchema<number | undefined, AnyObject>;
} = {
  location: yup.string().required('Please pick a location'),
  lat: yup
    .number()
    .typeError('Please pick a location with valid latitude')
    .min(-90, 'Latitude of location cannot be less than -90')
    .max(90, 'Latitude of location cannot be greater than 90')
    .required('Please pick a location with latitude'),
  lng: yup
    .number()
    .typeError('Please pick a location with valid longitude')
    .min(-180, 'Longitude of location cannot be less than -180')
    .max(180, 'Longitude of location cannot be greater than 180')
    .required('Please pick a location with longitude'),
};
